import { useLocation } from 'react-router-dom';
import { History } from 'history';

export const useQuery = () => new URLSearchParams(useLocation().search);

// Global history instance for programmatic navigation
let globalHistory: History | null = null;

export const setGlobalHistory = (history: History) => {
  globalHistory = history;
};

export const getGlobalHistory = () => globalHistory;

/**
 * Navigate to a route programmatically
 * Useful for navigation from services or contexts where useHistory is not available
 */
export const navigateTo = (path: string) => {
  console.warn('[ROUTING] 🧭 Attempting to navigate to:', path);
  console.warn('[ROUTING] 🔍 Global history available:', !!globalHistory);

  if (globalHistory) {
    console.warn('[ROUTING] ✅ Navigating with global history...');
    globalHistory.push(path);
    console.warn('[ROUTING] ✅ Navigation completed');
  } else {
    console.warn(
      '[ROUTING] ❌ Global history not available. Make sure to call setGlobalHistory during app initialization.',
    );
  }
};

/**
 * Process notification route and navigate
 * Handles routes that come from Firebase notifications
 */
export const handleNotificationRoute = (route: string) => {
  if (!route) {
    console.warn('[ROUTING] No route provided, navigating to fallback');
    navigateTo('/portfolios');
    return;
  }

  // Handle different route formats
  let processedRoute = route;

  // If route starts with 'f"', it's a Python f-string format - extract the actual route
  if (route.startsWith('f"') && route.endsWith('"')) {
    processedRoute = route.slice(2, -1); // Remove f" and "
  }

  // If route starts with 'f"/' directly, handle it
  if (route.startsWith('f"/')) {
    processedRoute = route.slice(2); // Remove f"
    if (processedRoute.endsWith('"')) {
      processedRoute = processedRoute.slice(0, -1); // Remove trailing "
    }
  }

  console.log('[ROUTING] Processing notification route:', route, '-> Processed:', processedRoute);

  // Basic safety check - ensure route starts with '/'
  if (!processedRoute.startsWith('/')) {
    console.warn('[ROUTING] Route does not start with "/", prepending it:', processedRoute);
    processedRoute = '/' + processedRoute;
  }

  // Navigate to the processed route
  console.log('[ROUTING] Navigating to route from notification:', processedRoute);
  navigateTo(processedRoute);
};
